import React, { Fragment, useState } from "react"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import Menu from "../../assets/images/menu.svg"
import { Dialog, Transition } from "@headlessui/react"
import { PORTAL_URL } from "../../utils/Constants"
import UserImg from "../../assets/images/user.svg"
import { Tooltip as ReactTooltip } from "react-tooltip"

const Header = ({ data }) => {
  const location = useLocation()
  const pathName = location.pathname
  const [open, setOpen] = useState(false)

  const SideMenu = ({ children }) => {
    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="absolute   z-10 inset-0 overflow-hidden"
          onClose={setOpen}
        >
          <div className="absolute inset-0 overflow-hidden">
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <div className="relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4">
                      <button
                        type="button"
                        className="header-btn rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <svg
                          class="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll">
                    <div className="px-4 sm:px-6">
                      <Dialog.Title className="text-lg font-medium text-gray-900">
                        Menu
                      </Dialog.Title>
                    </div>
                    <div className="mt-6 relative flex-1 px-4 sm:px-6">
                      {/* Replace with your content */}
                      <div className="absolute inset-0 px-4 sm:px-6">
                        {children}
                        <div className="mb-4"></div>
                        <hr />
                        <div className="mb-4"></div>
                      </div>
                      {/* /End replace */}
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
  }

  const MenuItems = ({ pathName }) => {
    return (
      <ul className="main-header__menu__inner">
        <Link to="/">
          <li className={pathName === "/" ? "active" : ""}>Home</li>
        </Link>
        <Link to="/services">
          <li className={pathName.includes("/services") ? "active" : ""}>
            Services
          </li>
        </Link>
        <Link to="/plan-and-pricing">
          <li
            className={pathName.includes("/plan-and-pricing") ? "active" : ""}
          >
            Plans & Pricing
          </li>
        </Link>
        <Link to="/faq">
          <li className={pathName.includes("/faq") ? "active" : ""}>FAQs</li>
        </Link>
        <Link to="/support-center">
          <li className={pathName.includes("/support-center") ? "active" : ""}>
            Support Center
          </li>
        </Link>
        <Link to="/private-labelling-solution">
          <li className={pathName.includes("/private-labelling-solution") ? "active" : ""}>
            Private Label
          </li>
        </Link>
        <Link to="/about-us">
          <li className={pathName.includes("/about-us") ? "active" : ""}>
            About Us
          </li>
        </Link>
        <Link to="/contact-us">
          <li className={pathName.includes("/contact-us") ? "active" : ""}>
            Contact Us
          </li>
        </Link>
        {/* <Link to="/order-tracking">
          <li className={pathName.includes("/order-tracking") ? "active" : ""}>
            Tracking
          </li>
        </Link> */}
        <div className="main-header__menu__inner__action">
          <Link to="/doctor-registration">
            <li
              className={
                pathName.includes("/doctor-registration") ? "active" : ""
              }
            >
              <button>Sign Up</button>
            </li>
          </Link>
          <Link to={`${PORTAL_URL}`}>
            <li>
              <span
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <UserImg />
                Login
              </span>
            </li>
          </Link>
        </div>
      </ul>
    )
  }

  return (
    <>
      <div className="main-header">
        <div className="main-header__logo">
          <Link to="/">
            <img
              src="https://alignerbase-public.s3.us-east-2.amazonaws.com/alignerbase-web-nav-logo.png"
              width={"250px"}
              height={"50px"}
            />
          </Link>
          <div className="main-header__logo__tagline">
            Empowering Practitioners, Advancing Orthodontics.
          </div>
        </div>

        <div className="hidden lg:flex main-header__menu">
          <MenuItems pathName={pathName} />
        </div>

        <div className="flex lg:hidden main-header__hamburger-menu">
          <Menu onClick={() => setOpen(true)} />
          <SideMenu className="main-header__menu">
            <MenuItems pathName={pathName} />
          </SideMenu>
        </div>
      </div>
    </>
  )
}

export default Header
